// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__NRO79","toggleSwitchContainer":"Footer_toggleSwitchContainer__lvMQz"};